import {
  AssetOptionsContext,
  type AssetOptionsContextProps,
  DEFAULT_MAX_SVG_HEIGHT,
  DEFAULT_MIN_SVG_WIDTH,
} from '@contexts/asset-options'
import { ContentType } from '@entries/content-types'
import ContentfulAsset from '@entries/contentful-asset'
import ContentfulOfferLanding from '@entries/contentful-offer-landing'
import { withDisplayName } from '@hocs/with-display-name'
import { OpenFormButton } from '@layouts/open-form-button'
import { Entry } from '@resolvers/entry'
import { graphql } from 'gatsby'
import React from 'react'

const assetOptions: AssetOptionsContextProps = {
  width: '259px',
  height: 'auto',
  minSvgWidth: DEFAULT_MIN_SVG_WIDTH,
  maxSvgHeight: DEFAULT_MAX_SVG_HEIGHT,
  objectFit: 'contain',
  alt: 'logo',
}

const ContentfulPageImageTitleLandingHeroFosfo: Utils.EntryFC<
  Queries.ContentfulPageImageTitleLandingHeroFosfoFragment
> = ({ content: { offerRef, image }, entryInspectorProps }) => (
  <div
    className="overflow-hidden bg-[linear-gradient(180deg,_#2593A5_0%,_#002B36_100%)] pb-8 tablet:rounded-sm laptop:text-center"
    {...entryInspectorProps()}
  >
    {image && (
      <div className="flex -translate-y-[45px] translate-x-0 scale-100 transform justify-center laptop:-translate-x-[35px] laptop:-translate-y-[35px] laptop:scale-[1.4]">
        <div className="3D-effect text-theme-primary hero-fosfo-img rounded-md">
          <AssetOptionsContext.Provider value={assetOptions}>
            <Entry
              content={image}
              mapping={{
                [ContentType.ContentfulAsset]: ContentfulAsset,
              }}
            />
          </AssetOptionsContext.Provider>
        </div>
      </div>
    )}
    <Entry
      content={offerRef}
      mapping={{
        [ContentType.ContentfulOffer]: ContentfulOfferLanding,
      }}
    />
    <OpenFormButton />
  </div>
)

export const query = graphql`
  fragment ContentfulPageImageTitleLandingHeroFosfo on Contentful3TUjMz7TxKWiQYygwIysig {
    ...ContentfulEntry
    image {
      ...ContentfulDefaultAsset
    }
    offerRef {
      ...ContentfulOffer
    }
  }
`

export default withDisplayName(
  ContentfulPageImageTitleLandingHeroFosfo,
  'ContentfulPageImageTitleLandingHeroFosfo'
)
